import alexsander from '../../Assets/Tutor/Alexsander.png';
import sandeep from '../../Assets/Tutor/Sandeep.png';

export const TutorList = [
    { id: 1, name: 'Gera Omene', photo: null, school: 'Texas Christian University' },
    { id: 2, name: 'Sandeep Tiwari', photo: sandeep, school: 'Texas Christian University' },
    { id: 3, name: 'Alexander Himstead', photo: alexsander, school: 'Chapman University' },
];